
const language = {
   
    "en-US": {
        "Both": "Both",
        "Hold": "Hold",
        "OVR": "OVR",
        "No": "No",
    },
    "es-MX": {
        "Both": "Ambos",
        "Hold": "Matenga",
        "OVR": "Anular",
        "No": "No",
    },
    "fr-CA": {
        "Both": "Les Deux",
        "Hold": "Retenir",
        "OVR": "Surpasser",
        "No": "Non",
    },
    "ja-JP": {
        "Both": "Both",
        "Hold": "Hold",
        "OVR": "OVR",
        "No": "No",
    },
    "ko-KR": {
        "Both": "Both",
        "Hold": "Hold",
        "OVR": "OVR",
        "No": "No",
    },
    "de-DE": {
        "Both": "Beide",
        "Hold": "Halten",
        "OVR": "Entfernen",
        "No": "Nein",
    },
    "ro-RO": {
        "Both": "Ambii",
        "Hold": "Suspendat",
        "OVR": "ExcepÈ›ie",
        "No": "nu",
    },
    "nl-NL": {
        "Both": "Both",
        "Hold": "Hold",
        "OVR": "OVR",
        "No": "nee",
    },
    "en-AU": {
        "Both": "Both",
        "Hold": "Hold",
        "OVR": "OVR",
        "No": "No",
    },
    "en-GB": {
        "Both": "Both",
        "Hold": "Hold",
        "OVR": "OVR",
        "No": "No",
    },
};

export default language;
